module.exports = __webpack_public_path__ + "img/agri-assist.bf3aeb1a.png";